import Spinner from "src/components/ui/spinner";

export default function LoadingScreen() {
  return (
    <div className="mt-10 flex justify-center">
      <Spinner width={16} height={16} />
    </div>
  );
}
